import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";
import { TheVoidPage } from "./pages/TheVoidPage";
import { ArchitectsDesignPage } from "./pages/ArchitectsDesignPage";
import { OceanOfWordsPage } from "./pages/OceanOfWordsPage";
import { CreationPage } from "./pages/CreationPage";
import { PathwaysPage } from "./pages/PathwaysPage";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/the-void" element={<TheVoidPage />} />
        <Route path="/architects-design" element={<ArchitectsDesignPage />} />
        <Route path="/ocean-of-words" element={<OceanOfWordsPage />} />
        <Route path="/creation" element={<CreationPage />} />
        <Route path="/pathways" element={<PathwaysPage />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;